import { AudioShare as AudioShareItem } from 'app/components/Shares/types';
import { useAppDispatch } from 'app/store';
import { useFetch } from 'app/utils/hooks';
import { apiErrorHandler, triggerDownload } from 'app/utils/utils';
import { ApiErrorCodeTypes } from 'types/enums';
import { addAlertAction } from 'app/store/Alerts/slice';
import { EXPIRED_SHARE_LINK_MESSAGE } from 'app/components/Shares/Share404/constants';
import { ActionResponse } from 'app/components/Shares/AudiosShare/types';

interface UseOnDownloadSharedAudioProps {
  audio?: AudioShareItem;
}

export const useDownloadSharedAudio = ({
  audio,
}: UseOnDownloadSharedAudioProps) => {
  const dispatch = useAppDispatch();
  const downloadAudio = useFetch<{}, ActionResponse>();

  const onDownloadAudio = async () => {
    const link = audio?._links.downloadAudio?.href || '';
    try {
      if (!audio || !link) {
        throw new Error();
      }
      const { response } = await downloadAudio.callAPI(link);
      triggerDownload(response._links.action.href || '', audio.title);
    } catch (e: any) {
      const statusReason = e?.response?.data?.error?.statusReason;

      switch (statusReason) {
        case ApiErrorCodeTypes.FORBIDDEN: {
          dispatch(
            addAlertAction({
              message: 'Audio file download is no longer available',
            })
          );
          break;
        }
        case ApiErrorCodeTypes.ENTITY_NOT_FOUND: {
          dispatch(addAlertAction({ message: EXPIRED_SHARE_LINK_MESSAGE }));
          break;
        }
        default: {
          dispatch(addAlertAction({ message: apiErrorHandler(e.response) }));
        }
      }
    }
  };

  return {
    onDownloadAudio: audio?._links.downloadAudio?.href
      ? onDownloadAudio
      : undefined,
  };
};
